import React from "react";

import MenuNav from "../../components/portfolio/menu-nav.component";
import PortfolioFooter from "../../components/portfolio/portfolio-footer.component";
import Divider from "../../components/portfolio/divider.component";
import ProjectList from "../../components/projectlist/projectlist.component.jsx";

import "./work.styles.css";
import Navbar from "../../components/navbar/navbar.component.jsx";

const Work = () => (
  <div>
    <Navbar/>
  <div className="page-wrapper">
    <section className="page-section">
      <h1 className="page-title">Projects</h1>
      <ProjectList />
    </section>
    <Divider />
    <PortfolioFooter />
  </div>
  </div>
);

export default Work;
